"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CheckCircle = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SvgIcon = _interopRequireWildcard(require("./SvgIcon"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var CheckCircle = exports.CheckCircle = function CheckCircle(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], _extends({
    fill: "none"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M10.5 16.5605l-3.75-3.7508L7.8098 11.75 10.5 14.4395 16.1888 8.75 17.25 9.8112l-6.75 6.7493z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M12 2a10.5 10.5 0 100 20.9999A10.5 10.5 0 0012 2zm0 19.5a8.9996 8.9996 0 01-8.315-5.5558A9.0002 9.0002 0 0115.4443 4.1851 8.9999 8.9999 0 0121 12.5a9.0002 9.0002 0 01-9 9z"
  }));
};
CheckCircle.propTypes = process.env.NODE_ENV !== "production" ? {
  kind: _propTypes["default"].oneOf(Object.keys(_SvgIcon.KIND)),
  size: _propTypes["default"].oneOf(Object.keys(_SvgIcon.SIZE)),
  title: _propTypes["default"].string,
  color: _propTypes["default"].oneOf(Object.keys(_SvgIcon.COLOR)),
  htmlColor: _propTypes["default"].string,
  fontSize: _propTypes["default"].oneOf(['medium', 'inherit', 'small', 'large']),
  viewBox: _propTypes["default"].string
} : {};
CheckCircle.defaultProps = {
  viewBox: '0 0 24 24'
};
var _default = exports["default"] = CheckCircle;